<script setup>
import { useI18n } from "vue-i18n";

defineProps(["modelValue"]);
defineEmits(["update:modelValue"]);

const { t: __ } = useI18n();
</script>

<template>
    <div>
        <div class="block text-sm font-medium leading-6 text-gray-900 dark:text-white">
            {{ __("Aperçu") }}
        </div>
        <div v-if="modelValue.title.value" class="mt-2 text-xs text-gray-600 dark:text-gray-400">{{ modelValue.title.value }}</div>
        <div v-if="modelValue.display_mode === 'inline'" class="mt-2 space-y-3">
            <template v-for="i in 3">
                <div class="w-full grid grid-cols-3 gap-x-3">
                    <div v-if="modelValue.elements.thumbnail" class="aspect-[4/3] col-span-1 bg-gray-300 dark:bg-gray-700"></div>
                    <div :class="[modelValue.elements.thumbnail ? 'col-span-2' : 'col-span-full', 'space-y-1']">
                        <div v-if="modelValue.elements.title" class="w-8/12 h-4 bg-gray-300 dark:bg-gray-700"></div>
                        <div v-if="modelValue.elements.excerpt" class="space-y-0.5">
                            <div class="w-full h-2 bg-gray-300 dark:bg-gray-700"></div>
                            <div class="w-9/12 h-2 bg-gray-300 dark:bg-gray-700"></div>
                            <div class="w-8/12 h-2 bg-gray-300 dark:bg-gray-700"></div>
                            <div class="w-10/12 h-2 bg-gray-300 dark:bg-gray-700"></div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <div v-else-if="modelValue.display_mode === 'grid'" class="flex mt-2 space-x-3">
            <template v-for="i in parseInt(modelValue.settings.grid.columns)">
                <div class="w-full flex flex-col space-y-3">
                    <div class="w-full flex flex-col space-y-3">
                        <div v-if="modelValue.elements.thumbnail" class="aspect-[4/3] bg-gray-300 dark:bg-gray-700"></div>
                        <div class="space-y-1">
                            <div v-if="modelValue.elements.title" class="w-8/12 h-4 bg-gray-300 dark:bg-gray-700"></div>
                            <div v-if="modelValue.elements.excerpt" class="space-y-0.5">
                                <div class="w-full h-2 bg-gray-300 dark:bg-gray-700"></div>
                                <div class="w-9/12 h-2 bg-gray-300 dark:bg-gray-700"></div>
                                <div class="w-8/12 h-2 bg-gray-300 dark:bg-gray-700"></div>
                                <div class="w-10/12 h-2 bg-gray-300 dark:bg-gray-700"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
